export const DOWNLOAD_STORYBOOK = 'Download Video';
export const EDITOR_PAGE = 'Editor Page';
export const EXPORT_VIDEO = 'Export Video';
export const PREVIEW_AUDIO = 'Preview Audio';
export const PREVIEW_STORYBOOK = 'Preview Storybook';
export const PREVIEW_VIDEO = 'Preview Video';
export const TEMPLATE_PAGE = 'Template Page';
